import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuthService } from './auth-service';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService,) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.authService.setInterceptedResponse(event);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this.authService.setInterceptedResponse(error);
        return throwError(error);
      })
    );
  }
}
